<div class="container" id="spinerLoader" *ngIf="loader">
    <div class="loader">Loading...</div>
</div>
<div class="modal-header py-0">
    <div class="d-flex justify-content-between">
        <span>
            <h4>{{dialogData.headerName}}</h4>
        </span>
        <button type="button" class="close close-btn" mat-dialog-close
            (click)="closeModel();resetForm(addEditMembersForm)">
            <i class="fa fa-close fa-md"></i>
        </button>
    </div>
</div>
<form name="addEditMembersForm" #addEditMembersForm="ngForm">
    <mat-dialog-content>
        <div class="modal-body scrollbarView" id="modal-body">
            <div class="member-card">
                <h4 class="filter-options inline" style="display: inline;">Account Details</h4>


                <div class="text-right mr-2" *ngIf="!isMemberEdit" style="display: inline; float: right;">
                    <label>
                        <input type="checkbox" name="diffuser" [(ngModel)]="isDifferentUserName" />
                        <span> as a guest user </span>
                    </label>
                </div>
                <br><br>
                <div class="row profile-section" *ngIf="isMemberEdit">
                    <div class="col-md-3">
                        <img class="member-img member-img-height" [src]="memberImage" alt="..." />
                    </div>
                    <div class="col-md-9 profile-details">
                        <div class="col-md-12 ml-0 pl-0">
                            <label class="col-md-4">Email</label>
                            <label class="label-header-color col-md-8 padding-input breakWord">{{
                                memberDetail?.contact.emailId
                                }}</label>
                        </div>

                        <div class="col-md-12 ml-0 pl-0">
                            <label class="col-md-4">Profile Image </label>
                            <label class="label-header-color col-md-8 padding-input breakWord d-flex">
                                <input type="file" class="mt-2 cursorPointer" accept=".jpg,.jpeg,.png" name="fName"
                                    id="editProfile" name="editMemberProfile" [(ngModel)]="editMemberProfile"
                                    (input)="uploadMemberProfile($event, editMemberProfile, 'editProfile', true)"
                                    [style.width]="imageName != undefined ? '85px' : '100%'" />
                                <span *ngIf="imageName != undefined" class="mt-2 ml-2">{{
                                    imageName
                                    }}</span>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="!isMemberEdit">
                    <div class="col-md-6">
                        <div class="form-group">
                            <div>
                                <label>Email ID<span class="text-danger" *ngIf="!isDifferentUserName"><b>*</b></span></label>
                                <input type="email"
                                       (change)="checkUserExist(memberDetail.contact.emailId);checkEmailValidForAdmin(email.value)"
                                       name="email" id="CMemail" #email="ngModel" class="form-control" placeholder="Email"
                                       pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,4}$" autocomplete="new-password"
                                       [(ngModel)]="memberDetail.contact.emailId" [disabled]="isDifferentUserName"
                                       [ngClass]="{ 'is-invalid': addEditMembersForm.submitted && email.invalid && !isDifferentUserName }"
                                       required
                                />
                                <div *ngIf="addEditMembersForm.submitted && email.invalid && !isDifferentUserName"
                                    class="invalid-feedback">
                                    <div *ngIf="email.errors.required">
                                        <span class="text-danger"> Email is required.</span>
                                    </div>
                                    <div *ngIf="email.errors.pattern">
                                        <span class="text-danger">Email not valid.</span>
                                    </div>
                                    <div class="text-danger" *ngIf="emailError">User already exists.</div>
                                </div>
                                <div class="text-danger" *ngIf="isEmailErrorForExecutiveAdminRole"> Email Id must
                                    contain "@trinityairmedical.com" or "@srta.com" for Executive Admin Role </div>
                                <div class="text-danger" class="pl-1" *ngIf="emailError">User already exists.</div>

                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <div>
                                <label>Password
                                    <span class="text-danger" *ngIf="!isDifferentUserName"><b>*</b>&nbsp;
                                        <i class="fa fa-question-circle fa-lg red-tooltip" aria-hidden="true"
                                            data-toggle="tooltip" title="Password must be minimum of 8 characters with 1 uppercase,
                              1 lowercase, 1 digit and 1 special symbol."></i>

                                    </span></label>
                                <input type="password" name="password" id="password" #password="ngModel"
                                       class="form-control" placeholder="Password" title="Password must be minimum of 8 characters with 1 uppercase,
                              1 lowercase, 1 digit and 1 special symbol."
                                       pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*?[0-9])(?=.*?[!@#$%^&*+`~'=?\|\]\[\(\)\-<>/]).{8,}"
                                       [disabled]="isDifferentUserName" [(ngModel)]="memberDetail.password" [ngClass]="{
                              'is-invalid':
                                addEditMembersForm.submitted &&
                                email.invalid &&
                                !isDifferentUserName
                            }" required />
                            </div>
                            <div *ngIf="
                            addEditMembersForm.submitted &&
                            password.invalid &&
                            !isDifferentUserName
                          " class="invalid-feedback">
                                <div *ngIf="password.errors.required">
                                    <span class="text-danger">
                                        Password must be minimum of 8 characters with 1
                                        uppercase, 1 lowercase, 1 digit and 1 special
                                        symbol.</span>
                                </div>
                                <div *ngIf="password.errors.pattern">
                                    <span class="text-danger">Password must be minimum of 8 characters with 1
                                        uppercase, 1 lowercase, 1 digit and 1 special
                                        symbol.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" *ngIf="!isMemberEdit">
                    <div class="col-md-6">
                        <div class="form-group">
                          <label>System Role<span class="text-danger" *ngIf="!isDifferentUserName">*</span></label>
                          <div class="multirole-container text-bold float-right">Default Role</div>
                          <ng-container *ngFor="let role of roleList; let i = index">
                            <div class="multirole" id="role{{i}}">
                              <input type="checkbox" id="multiple-role-{{role?.rolename}}"
                                     [value]="role?.roleid"
                                     name="selectedMultipleRole"
                                     (change)="selectMultipleRole($event); checkEmailValidForAdmin(memberDetail.contact.emailId);"
                                     [checked]="(assignedDefaultRole == role?.roleid || assignedMultipleRoles.has(role?.roleid)) && !isDifferentUserName"
                                     [disabled]="assignedDefaultRole == role?.roleid || memberDetail.isGuestUser || isDifferentUserName"
                              >
                              {{ role?.rolename }}
                              <input type="radio"
                                     id="default-role-{{role?.rolename}}"
                                     class="float-right"
                                     [value]="role?.roleid" name="defaultRole"
                                     [(ngModel)]="assignedDefaultRole"
                                     (change)="isDefaultRoleSelected = !!assignedDefaultRole; checkEmailValidForAdmin(memberDetail.contact.emailId)"
                                     [disabled]="isDifferentUserName"
                                     [checked]="assignedDefaultRole && assignedDefaultRole == role?.roleid && !isDifferentUserName"
                              >
                            </div>
                          </ng-container>
                          <div *ngIf="isDefaultRoleSelected === false" class="invalid-feedback">
                            <span class="text-danger">Default role is required.</span>
                          </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Upload Profile Picture :</label>
                            <label class="d-flex">
                                <input type="file" class="mt-2 cursorPointer" accept=".jpg,.jpeg,.png" id="profile"
                                    name="memberImage" [(ngModel)]="memberImage"
                                    (input)="uploadMemberProfile($event, memberImage, 'profile', true);" />
                            </label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="member-card">
                <h4 class="filter-options">Personal Details</h4>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>First Name<span class="text-danger">*</span></label>
                            <input type="text" id="addFirstName" placeholder="First Name" name="add_FirstName"
                                #add_FirstName="ngModel" class="form-control" [(ngModel)]="memberDetail.firstName"
                                [ngClass]="{
                            'is-invalid':
                              addEditMembersForm.submitted && add_FirstName.invalid
                          }" required />
                            <div *ngIf="
                            addEditMembersForm.submitted && add_FirstName.invalid
                          " class="invalid-feedback">
                                <div *ngIf="add_FirstName.errors.required">
                                    <span class="text-danger">First Name is required.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>MI</label>
                            <input type="text" id="addMiddleName" placeholder="MI" name="add_MiddleName"
                                class="form-control" [(ngModel)]="memberDetail.middleName" />
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Last Name<span class="text-danger">*</span></label>
                            <input type="text" id="addLastName" placeholder="Last Name" name="add_LastName"
                                #add_LastName="ngModel" class="form-control" [(ngModel)]="memberDetail.lastName"
                                [ngClass]="{
                            'is-invalid':
                              addEditMembersForm.submitted && add_LastName.invalid
                          }" required />
                            <div *ngIf="addEditMembersForm.submitted && add_LastName.invalid" class="invalid-feedback">
                                <div *ngIf="add_LastName.errors.required">
                                    <span class="text-danger">Last Name is required.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group">
                            <label>Mobile Number<span class="text-danger"><b>*</b></span></label>
                            <input type="text" (blur)="memberCheckByPhone(memberDetail.contact.phoneNumber)"
                                id="addMobileNumber" placeholder="(xxx) xxx-xxxx" name="add_MobileNumber"
                                #add_MobileNumber="ngModel" (ngModelChange)="memberDetail.contact.phoneNumber = $event"
                                [ngModel]="memberDetail.contact.phoneNumber | phoneNumberPipe" maxlength="14"
                                minlength="14" pattern="\(?\d+\)?[-.\s]?\d+[-.\s]?\d+" class="form-control" [ngClass]="{
                            'is-invalid':
                              addEditMembersForm.submitted && add_MobileNumber.invalid
                          }" required />
                            <div *ngIf="
                            addEditMembersForm.submitted && add_MobileNumber.invalid
                          " class="invalid-feedback">
                                <div *ngIf="add_MobileNumber.errors.required">
                                    <span class="text-danger">Phone Number is required.</span>
                                </div>
                                <div *ngIf="add_MobileNumber.errors.minlength">
                                    <span class="text-danger">Phone must have 10 digits.</span>
                                </div>
                                <div *ngIf="add_MobileNumber.errors.pattern">
                                    <span class="text-danger">Phone Number not valid.</span>
                                </div>
                            </div>
                            <div *ngIf="phoneError">
                                <span class="text-danger">Phone number already exists.</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4" *ngIf='isCustomer'>
                        <div class="form-group">
                            <label>Gender</label><span class="text-danger">*</span>
                            <div class="radio my-0">
                                <label><input type="radio" name="gender" [(ngModel)]="memberDetail.gender"
                                        [value]="genderType.male" required />Male</label>
                                <label class="ml-4"><input type="radio" name="gender" [(ngModel)]="memberDetail.gender"
                                        [value]="genderType.female" required />Female</label>
                                <label class="ml-4"><input type="radio" name="gender" [(ngModel)]="memberDetail.gender"
                                        [value]="genderType.anotherGender" required />Another Gender</label>
                            </div>
                            <div *ngIf="addEditMembersForm.submitted && addEditMembersForm.controls['gender'].invalid">
                                <span class="text-danger">Gender is required.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="member-card">
                <h4 class="filter-options">Address Details</h4>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Street Address</label>
                            <input type="text" name="streetAddress" id="CMStreetAddress" placeholder="Street Address"
                                class="form-control" [(ngModel)]="memberDetail.address.streetAddress" />
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Zipcode</label>
                            <input type="text" id="CMZipcode" placeholder="Zipcode" name="Zipcode" class="form-control"
                                maxlength="5" minlength="5" pattern="[0-9]+"
                                [(ngModel)]="memberDetail.address.zipcode" />
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>State</label>
                            <select name="memberDetail.address.stateId" class="form-control"
                                [(ngModel)]="memberDetail.address.stateId"
                                (change)="getCityBystate(memberDetail.address.stateId)">
                                <option selected disabled [value]="null">Select State</option>
                                <option *ngFor="let item of StateList" [value]="item.stateId">
                                    {{ item?.stateName }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>City</label>
                            <select name="city" class="form-control" [(ngModel)]="memberDetail.address.city">

                                <option value="" selected disabled>Select City</option>
                                <option *ngFor="let city of cityList" [value]="city.cityName">
                                    {{ city.cityName }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <div class="modal-footer pt-3 mb-3 col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right">
            <button type="button" class="flat-butt flat-danger-butt flat-danger-grad-butt margin-right-10"
                mat-dialog-close (click)="closeModel();resetForm(addEditMembersForm)">
                Cancel
            </button>
            <button type="submit" class="flat-butt flat-info-butt flat-info-grad-butt save-btn"
                (click)="saveData(addEditMembersForm)">
                Save Changes
            </button>
        </div>
    </mat-dialog-actions>
</form>
